import React, {Component} from 'react'

import style from './cards.sass'

class Cards extends Component {
  render() {
    return(
      <section styleName='wrapper'>
        <div styleName='container'>
          <div styleName='card'>
            <img src='/img/landing/home/build-icon.png' alt=''/>
            <h3>Build</h3>
            <p>
              Design executable strategies by typing out your ideas or using our standardized modules.
            </p>
          </div>
          <div styleName='card'>
            <img src='/img/landing/home/test-icon.png' alt=''/>
            <h3>Test</h3>
            <p>
              Test your algos using various sources of data on our simulated matching engine. Get more accurate results with our commission and slippage models.
            </p>
          </div>
          <div styleName='card'>
            <img src='/img/landing/home/automate-icon.png' alt=''/>
            <h3>Automate</h3>
            <p>
              Fully automate trading ideas or turn on alerts to receive a notification when your signals trigger.
            </p>
          </div>
        </div>
      </section>
    )
  }
}

export default Cards
